import React, { useEffect, useRef, useState } from "react";
import System from "../helper/system";
import $ from "jquery";
import { useAxiosIndicatorCheck } from "../store/hook/useAxiosIndicatorCheck";
import Manufacturers from "./UniversalSearch/Manufacturers";
import Categories from "./UniversalSearch/Categories";
import NewProductInformation from "./UniversalSearch/NewProductInformation";
import Documents from "./UniversalSearch/Documents";
import Videos from "./UniversalSearch/Videos";
import Events from "./UniversalSearch/Events";
import Articles from "./UniversalSearch/Articles";
import Other from "./UniversalSearch/Other";
import { __remove, __set } from "../store/axios_indicator";
import useDebounce from "../hooks/useDebounce";
import { useHomePageContentStore } from "src/hooks/HomePageContent";
import Common from "../pages/HomePageContent/Common";
import { useProductStore } from "src/hooks/product";
import ProductSearch from "./UniversalSearch/ProductSearch";
import Constants from "src/support/Constants";

const UniversalSearch = () => {
  const clsNm = "bs5 input-group flex-nowrap search-part"
  const [classToToggle, setClassToToggle] = useState(clsNm);
  const formRef = useRef(false);
  const [productList, setProductList] = useState({});
  const [manufacturerList, setManufacturerList] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [npiList, setNpiList] = useState([]);
  const [documentsList, setDocumentsList] = useState([]);
  const [articlesList, setArticlesList] = useState([]);
  const [videosList, setVideosList] = useState([]);
  const [DOM_id, set_DOM_id] = useDebounce("product", 1000);
  const [eventsList, setEventsList] = useState([]);
  const [otherContentList, setOtherContentList] = useState([]);
  const [isDisplaySuggestion, setDisplaySuggestion] = useState(false);
  const [{ }, { get_document_list_autosuggest, get_home_page_content },] = useHomePageContentStore();
  const [{ }, { get_universal_product_search_list, get_universal_category_manufacturers_search_list }] = useProductStore();
  const [__check] = useAxiosIndicatorCheck();
  const { NPI, SITE, EVENT, ARTICLE, DOCUMENT, CONTENT, VIDEO, OTHER } = Constants.homePageAllTabs;
  const [apiCall, setApiCall] = useState({ Product: false, Category: false, Manufacturer: false, Document: false, Article: false, Video: false, Event: false, Other: false, Npi: false });
  const apiCallKeys = ["Product", "Category", "Manufacturer", "Document", "Article", "Video", "Event", "Other", "Npi"];

  const [searchTerm, setSearchTerm] = useState(() => {
    const a = System.getParams().search;
    return a !== undefined ? a : "";
  });

  useEffect(() => {
    // autopopulate
    $(".search-box .form-control").on("input", function () {
      if (!$(this).val()) {
        $(".search-box-dropdown").removeClass("d-none");
      } else {
        $(".search-box-dropdown").addClass("d-block");
      }
    });

    // search category hover
    $(".search-categories .search-categories-name").hover(
      function () {
        $(".search-categories-name").removeClass("active");
        $(this).addClass("active");
        let getValue = $(this).attr("data-target");
        $(".search-item").removeClass("active");
        $("#" + getValue).addClass("active");
        // setSearchTab($(this).text())
      },
      function () { }
    );
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (formRef.current && !formRef.current.contains(event.target)) {
        setClassToToggle(clsNm);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [formRef]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchTerm !== false && searchTerm.length > 2 && isDisplaySuggestion) {
        await typingCompleted(searchTerm);
      } else {
        setClassToToggle(clsNm);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const addClassOnTabByID = (DOM_id_d = "product") => {
    set_DOM_id(DOM_id_d);
  };

  useEffect(() => {
    $(".search-categories-name").removeClass("active");
    $("#" + DOM_id + "-tab-link").addClass("active");
    let getValue = $("#" + DOM_id + "-tab-link").attr("data-target");
    $(".search-item").removeClass("active");
    $("#" + getValue).addClass("active");
  }, [DOM_id]);

  const fetchFromServer = async (searchTerm) => {
    searchTerm = searchTerm.trim();

    setApiCall(() => {
      const resetState = {};
      apiCallKeys.forEach(key => resetState[key] = false);
      return resetState;
    });

    __set("UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL");
    setClassToToggle(clsNm + " open");
    addClassOnTabByID("product");

    const promises = [
      get_universal_product_search_list(searchTerm),
      get_universal_category_manufacturers_search_list(searchTerm),
      get_document_list_autosuggest(searchTerm, 1, 5, "", "DocumentType"),
      get_home_page_content({ contentType: ARTICLE.contentType, searchTerm, pageNumber: 1, pageSize: 10 }),
      get_home_page_content({ contentType: VIDEO.contentType, searchTerm, pageNumber: 1, pageSize: 10 }),
      get_home_page_content({ contentType: EVENT.contentType, searchTerm, pageNumber: 1, pageSize: 10 }),
      get_home_page_content({ contentType: SITE.contentType, searchTerm, pageNumber: 1, pageSize: 10 }),
      get_home_page_content({ contentType: NPI.contentType, searchTerm, pageNumber: 1, pageSize: 10 }),
    ];

    const handlers = [
      (res) => {
        if (res && Object.keys(res).length > 0) {
          setProductList(res);
        }
      },
      (res) => {
        if (res?.Manufacturer?.length > 0) {
          setManufacturerList(res.Manufacturer);
        }
        if (res?.Categories?.length > 0) {
          setCategoriesList(res.Categories);
        }
      },
      (res) => {
        const docs = res?.payload?.data?.documentList;
        if (docs?.length > 0) {
          setDocumentsList(docs);
        }
      },
      (res) => {
        const articles = res?.articles?.webContentView;
        if (articles?.length > 0) {
          setArticlesList(articles);
        }
      },
      (res) => {
        const videos = res?.video?.webContentView;
        if (videos?.length > 0) {
          setVideosList(videos);
        }
      },
      (res) => {
        const events = res?.events?.webContentView;
        if (events?.length > 0) {
          setEventsList(events);
        }
      },
      (res) => {
        const other = res?.sitePages?.webContentView;
        if (other?.length > 0) {
          setOtherContentList(other);
        }
      },
      (res) => {
        const npi = res?.NPI?.webContentView;
        if (npi?.length > 0) {
          setNpiList(npi);
        }
      }
    ];
    await Promise.allSettled(promises.map((p, i) =>
      p.then((res) => {
        setApiCall(prev => ({ ...prev, [apiCallKeys[i]]: true }));
        handlers[i](res);
      }).catch(() => { })
    ));

    __remove("UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL");
  };

  const letsSearch = (searchTerm, allTabsCount = {}) => {
    let c = System.getParams();

    for (const key in c) {
      delete c[key];
    }

    c.search = searchTerm;
    history.pushState(null, null, "?" + $.param(c));

    if (searchTerm.length < 2) {
      searchTerm = "";
    }
    localStorage.setItem("universal_search_param", searchTerm);
    localStorage.setItem(System.storageName.UNIVERSAL_SEARCH, true);
    c.page = 1;
    if (c.viewAll) {
      delete c.viewAll;
    }
    localStorage.setItem("product_listing_page", 1);
    window.location.href = Common.getRedirectionURL(searchTerm, productList, allTabsCount, c, false);
    return false;
  };

  const displayClearIconStatus = () => {
    return searchTerm.length > 0;
  };

  const fromSubmitted = async (event) => {
    event.preventDefault();
    if (searchTerm.length < 2) {
      return false;
    }
    letsSearch(searchTerm);
  };

  const searchButtonPressed = async () => {
    let searchKey = searchTerm;
    if (searchTerm.length < 2) {
      searchKey = "";
      localStorage.setItem("universal_search_param", searchTerm);
      setSearchTerm(searchKey);
      return false;
    }

    searchKey?.toLowerCase()
      .replace("+", "and")
      .replace("&", "and")
      .replace(".", "")
      .replace(" ", "-")
      .replace("/", "-")
      .replace(",", "");

    letsSearch(searchTerm); // allTabsCount
    return false;
  };

  const typingCompleted = async (searchTerm) => {
    setProductList({});
    setManufacturerList([]);
    setCategoriesList([]);
    setNpiList([]);
    setDocumentsList([]);
    setArticlesList([]);
    setVideosList([]);
    setEventsList([]);
    setOtherContentList([]);
    await fetchFromServer(searchTerm);
    if (searchTerm.length < 1) {
      setClassToToggle(clsNm);
      setProductList({});
    }
    localStorage.setItem("universal_search_param", searchTerm);
  };

  const onClearSearch = async () => {
    setProductList({});
    setSearchTerm("");
    setClassToToggle(clsNm);
  }


  return (
    <>
      <div className="col-xl-12 col-lg-12 col-12 header-search">
        <form
          ref={formRef}
          onSubmit={(event) => {
            event.preventDefault();
            fromSubmitted(event);
          }}
          className="search-box"
        >
          <div className={`global-search-input ${classToToggle}`}>
            <input type="text" className="form-control form-control-sm universal_search_input "
              id="search-dropdown" autoComplete="off"
              value={searchTerm}
              onPaste={(e) => {
                setSearchTerm(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  setSearchTerm(e.target.value);
                }
              }}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setDisplaySuggestion(true);
              }}
              placeholder="Enter keyword, item, model or part number."
              style={{ border: "none" }}
            />

            {displayClearIconStatus() && (
              <i className="cursor-pointer fa fa-times-circle close-global-search"
                onClick={async () => { onClearSearch(); }} />
            )}

            <a href={void 0} className="bs5 btn btn-primary h-auto zindex-5"
              onClick={() => { searchButtonPressed(); }} >
              {__check("UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL").status && (
                <i className="fa fa-spinner fa-spin" />
              )}
              {!__check("UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL").status && (
                <i className="fa fa-search" />
              )}
            </a>

            <div className="dropdown-menu search-part-dropdown" aria-labelledby="search-dropdown"            >
              <div className="bs5 row m-0 flex-nowrap h-100">
                <div className="col-auto p-0">
                  <div className="search-sidebar">

                    <div className="search-sidebar-title">
                      {searchTerm ? searchTerm :
                        System.getParams().search ? System.getParams().search : ""}
                    </div>

                    <div className="search-sidebar-inner">
                      <div className="search-categories">
                        <div className="search-categories-name"
                          id={"product-tab-link"}
                          data-target="search-1"
                          data-bs-target="search-1">
                          <span>Products</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"manufacturer-tab-link"}
                          data-target="search-2"
                          data-bs-target="search-2" >
                          <span>Manufacturers</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"categories-tab-link"}
                          data-target="search-3"
                          data-bs-target="search-3">
                          <span>Categories</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"npi-tab-link"}
                          data-target="search-4"
                          data-bs-target="search-4">
                          <span>New Product Information</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"documents-tab-link"}
                          data-target="search-5"
                          data-bs-target="search-5">
                          <span>Documents</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"articles-tab-link"}
                          data-target="search-6"
                          data-bs-target="search-6">
                          <span>Articles</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"videos-tab-link"}
                          data-target="search-7"
                          data-bs-target="search-7">
                          <span>Videos</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"events-tab-link"}
                          data-target="search-8"
                          data-bs-target="search-8">
                          <span>Events</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"other-tab-link"}
                          data-target="search-9"
                          data-bs-target="search-9">
                          <span>Other</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div className="bs5 col p-0">
                  <div className="search-content">
                    <div className="search-item" id="search-1">
                      <ProductSearch productList={productList} searchTerm={searchTerm} apiCall={apiCall} onProductSearch={async () => searchButtonPressed()} />
                    </div>
                    <div className="search-item" id="search-2">
                      <Manufacturers manufacturerList={manufacturerList} searchText={searchTerm} apiCall={apiCall} />
                    </div>
                    <div className="search-item" id="search-3">
                      <Categories categoriesList={categoriesList} searchText={searchTerm} apiCall={apiCall} />
                    </div>
                    <div className="search-item" id="search-4">
                      <NewProductInformation searchText={searchTerm} npiList={npiList} apiCall={apiCall} />
                    </div>
                    <div className="search-item" id="search-5">
                      <Documents searchText={searchTerm} documentsList={documentsList} apiCall={apiCall} />
                    </div>
                    <div className="search-item" id="search-6">
                      <Articles searchText={searchTerm} articlesList={articlesList} apiCall={apiCall} />
                    </div>
                    <div className="search-item" id="search-7">
                      <Videos searchText={searchTerm} videosList={videosList} apiCall={apiCall} />
                    </div>
                    <div className="search-item" id="search-8">
                      <Events searchText={searchTerm} eventsList={eventsList} apiCall={apiCall} />
                    </div>
                    <div className="search-item" id="search-9">
                      <Other searchText={searchTerm} otherContentList={otherContentList} apiCall={apiCall} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* input-group end.// */}
        </form >
      </div >
    </>
  );
};

export default UniversalSearch;
